import { AppLanguage } from '../../types';
import { baseApiClient } from '../clients';

const PROMOTIONS_URL = '/promotions';

const getPromotions = (lang: AppLanguage = AppLanguage.Danish, subjectId: string) =>
  baseApiClient.get(`${PROMOTIONS_URL}?language=${lang}&subjectId=${subjectId}`);

export default getPromotions;
